// sensei-app/common/schemas/collections/scheduledTopics.js
import { z } from "zod";

const ScheduledTopicSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    studentId: z.string().describe("The student this topic is scheduled for."),
    courseId: z.string().describe("The course this topic belongs to."),
    topicId: z.string().uuid().describe("Links to the TopicDefinition in the Course schema."),
    
    // Denormalized fields for easier UI rendering
    topicTitle: z.string(),
    topicType: z.enum(["class", "assessment", "assignment"]),

    scheduledDateTime: z.coerce.date().describe("The date and time the topic is scheduled for."),
    status: z.enum(["scheduled", "completed", "cancelled", "missed", "paused"]).default("scheduled"),
    
    // NEW: Track attendance and session state for resuming
    attendanceCount: z.number().int().default(0).describe("How many times the student has started this session."),
    sessionState: z.object({
        chatLog: z.array(z.any()).optional().describe("The full chat history for session replay."),
        // Add other state variables as needed, e.g., currentQuestionIndex for assessments
    }).optional().nullable().describe("Stores the state of a paused session."),

    // Link to the result document after completion
    resultDocumentId: z.string().optional().nullable().describe("e.g., AssessmentResult ID or Class transcript ID."),

    scheduledBy: z.string().describe("ID of the entity that scheduled the topic (user ID or agent contactId)."),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ScheduledTopicSchema;